// 用来扫描全局对象并自动注册。
// components/index.js
import Vue from 'vue'

// // 自动加载 global 目录下的 .js 结尾的文件
const componentsContext = require.context('./global', true, /\.js$/)
//console.log(componentsContext.keys())
componentsContext.keys().forEach(component => {
  const componentConfig = componentsContext(component)
  /**
  * 兼容 import export 和 require module.export 两种规范
  */
  const ctrl = componentConfig.default || componentConfig;
  Vue.component(ctrl.name, ctrl)
})
// 




// WEBPACK FOOTER //
// ./src/components/index.js